export const socialMedia = [
    {
        title : "Linkedin",
        url : "https://www.linkedin.com/in/aayushsrivastava9760/",
        image : "socials/linkedinLogo.png"
    }, 
    {
        title : "Twitter",
        url : "https://x.com/Aayush9760/",
        image : "socials/twitterLogo.png"
    }, 
    {
        title : "Hashnode",
        url : "https://aayush-srivastava.hashnode.dev/",
        image : "socials/hashnodeLogo.png"
    }, 
    {
        title : "Github",
        url : "https://github.com/aayushsrivastava9760/",
        image : "socials/githubLogo.png"
    }, 
    {
        title : "Instagram",
        url : "https://www.instagram.com/chill_iitian",
        image : "socials/instagramLogo.png"
    }, 
    {
        title : "Youtube",
        url : "https://www.youtube.com/@Chill_IITian",
        image : "socials/youtubeLogo.png"
    }
]